import Ajax from '@utils/ajax';

import {
	AxiosPromise,
} from 'axios';

export function deleteBenefitPlans(): AxiosPromise {
	return Ajax.delete('/payroll/deduction_sync/ajax/remove_benefit_data');
}
